// @ vendors
const { APIPost, APIGet, APIPatch } = require('utilities/APIRequestHelper');
const moment = require('moment');
const momentTz = require('moment-timezone');
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');
const Immutable = require('immutable');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;



// @ actions
const brokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const { searchSpecificIsin } = require('actions/brokerProductAdvancedSearch');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    BROKER_CONTRIBUTION_FUNDS_PRODUCT_URL_PARAMETER,
    FIRST_STEP,
    CHARGE_ACCOUNT_PREFIX,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_PRODUCT_TYPE_FUNDS_ES,
    BROKER_ORDER_TYPE_BUY,
    INTERVENER_TYPE_TITULAR,
    API_CHANNEL,
    PERIODICITY_DOCUMENT_SERVICE
} = require('constants/index');
const { ADD_SUSCRIPTION_ERROR } = require('constants/contactCenter/contributionFundsActionErrorTypes');
const { COUNTRIES_CODES: { DE, PT } } = require('constants/countries');
// @ helpers
const  { showMemories } = require( 'commonsUtilities/showMemoriesHelper');
// @utils
const PersonalDataHelper = require('utilities/personalDataHelper');
const translateExantCostKey = require('utilities/translationExantCost');
const toFirstUppercase = require('utilities/stringHelper').toFirstUppercase;
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');


const showLoading = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_CONTRIBUTION_FUNDS_SHOW_LOADING,
        payload: true
    });
};

const hideLoading = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_CONTRIBUTION_FUNDS_SHOW_LOADING,
        payload: false
    });
};

const requestContributionFundsInProgress = () => ({
    type: actionTypes.FETCH_BROKER_CONTRIBUTION_FUNDS_REQUEST
});

const requestContributionFundsSuccess = (data, response) => ({
    type: actionTypes.FETCH_BROKER_CONTRIBUTION_FUNDS_SUCCESS,
    payload: {
        contributionFunds: data,
        securityDetails: response
    }
});

const requestContributionFundsFailure = (error, errorType = '') => ({
    type: actionTypes.FETCH_BROKER_CONTRIBUTION_FUNDS_FAILURE,
    payload: {
        error,
        errorType
    }
});

const requestContributionFundsNotFound = () => ({
    type: actionTypes.FETCH_BROKER_CONTRIBUTION_FUNDS_NOT_FOUND,
    payload: {
        error: formatText('brokerHireInvestmentStep1-nonExistingFund')
    }
});

const reset = () => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_RESET
});

const setAccountNumber = (accountId, accountAmount, linkedToRobo) => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_ACCOUNT_NUMBER,
    payload: {
        accountId,
        accountAmount,
        linkedToRobo,
    }
});

const setVisibleStep = step => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_VISIBLE_STEP,
    payload: {
        step
    }
});
const setValidityDateValue = date => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_DATE_VALUE,
    payload: {
        date
    }
});

const setValidityDate = date => dispatch => {
    dispatch(setValidityDateValue(date));
};

const setPeriodicity = (value) => {
    return ({
        type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_PERIODICITY,
        payload: {
            value: value.value,
            label: value.label,
        }
    })
};

const setWillLeave = () => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_WILL_LEAVE
});

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_CHANGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const subscriptionSuccess = (hiredFunds) => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_CHANGE_SUCCESS,
    payload: { hiredFunds }
});

const changeReadChecked = checked => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_CHANGE_READCHECKED,
    payload: {
        checked
    }
});

const setAmount = amount => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_AMOUNT,
    payload: {
        amount
    }
});

const validateStep = step => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_CHANGE_VALIDATE_STEP,
    payload: {
        step
    }
});

const getAccountSuccess = data => ({
    type: actionTypes.FETCH_BROKER_GET_ACCOUNTS_CONTRIBUTION_SUCCESS,
    payload: {
        data
    }
});

const requestExtantCostsBuyFundsProgress = () => ({
    type: actionTypes.BROKER_EXTANT_COST_FETCH_FETCHING
});

const requestExtantCostsBuyFundsSuccess = (response) => ({
    type: actionTypes.BROKER_EXTANT_COST_FETCH_SUCCESS,
    payload: response
});

const requestExtantCostsBuyFundsFailure = (error, errorType = '') => ({
    type: actionTypes.BROKER_EXTANT_COST_FETCH_FAILURE,
    payload: {
        error,
        errorType
    }
});

const postExtantCostsBuyFunds = (query, history) => (dispatch) => {
    const { importe: {amount, currency}, isin } = query;
    const requestData = {
        header: {
            version: 2
        },
        query: {
            importe: {
                amount,
                currency
            },
            isin,
            recurringTransferAmount: {
                amount,
                currency
            }
        }
    };
    dispatch(requestExtantCostsBuyFundsProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerBuyFundsExtantCosts'), requestData)
        .then(response => dispatch(requestExtantCostsBuyFundsSuccess(response)))
        .catch(response => {
            dispatch(requestExtantCostsBuyFundsFailure(response.error)); dispatch(errorActions.show('', true, history));
        });

}

const getAccounts = (dispatch, getState) => {
    const contributionFunds = getState().contributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds']);
    const type = contributionFunds.get('type');
    const subtype = contributionFunds.get('subtype');
    const reference = contributionFunds.get('reference');

    const requestData = {
        header: {
            version: 2
        },
        query: {
            pais: 'ES', // @hardcoded
            referencia: reference,
            segmento: 'PA', // @hardcoded
            subtipo: subtype,
            tipo: type
        }
    };

    dispatch(requestContributionFundsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetAccountsInvestment'), requestData)
        .then(response => dispatch(getAccountSuccess(response)))
        .catch(response => dispatch(requestContributionFundsFailure(response.error)));
};

function contributionFundsDocumentStorageRequest(){
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_REQUEST
    }
}

function contributionFundsDocumentStorageSuccess() {
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_SUCCESS
    };
}

function contributionFundsDocumentStorageError() {
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_ERROR
    };
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
        ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
        : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

const getHolders = (interveners) => {
    let holderNames = [];
    holderNames = interveners.filter((intervener) => {
        return intervener.get('type').trim() === INTERVENER_TYPE_TITULAR
    }).map(holder => {
        return holder.get('name').trim()
    });
    return holderNames;
}

const storeDocument = (orderResponse) => (dispatch, getState) => {
    let communicationServiceInput, data;
    const immProfile = getState().profile;
    const originCountry = immProfile.get('originCountry');
    const immContributionFunds = getState().contributionFunds;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const amount = parseFloat(immContributionFunds.getIn(['steps', FIRST_STEP, 'amount']));
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(immContributionFunds.getIn(['steps', FIRST_STEP, 'accountNumber']));
    const controlDigit = trim(immAccount.getIn(['ibanComplex', 'digitodecontrol']));
    const contractNumber = trim(immAccount.get('contractNumber'));
    const productNumber = trim(immAccount.get('product'));
    const currency = immAccount.getIn(['balance', 'currency']);
    const isin =immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'isin']);
    const emittedDateTime = immContributionFunds.getIn(['steps', FIRST_STEP, 'selectedDate']);
    const fundName =immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'name']);
    const interveners = immContributionFunds.getIn(['steps', FIRST_STEP, 'interveners']);
    const ffShowExantCost = immFlagBasedFeatures.get('wealth_funds_buy_show_costs');
    const holderNames = getHolders(interveners);

    const immBrokerFundLegalDocument =  getState().brokerFundLegalDocument;
    const productKidDocumentUrl = immBrokerFundLegalDocument.get('fundamentalDataForInvesorUrl');
    let marketingReportUrl = ''
    if (immProfile.get('originCountry').toUpperCase() !== DE) {
        marketingReportUrl = immBrokerFundLegalDocument.get('marketingReportsUrl');
    }
    const economicReportUrl = immBrokerFundLegalDocument.get('lastPublishedEconomicReportUrl');
    const immFundTransactionCostDocument = immBrokerFundLegalDocument.getIn(['fundTransactionCostDocument', isin]);
    const costYieldObjectId = immFundTransactionCostDocument ? immFundTransactionCostDocument.get('objectId') : '';
    const cantidadParticipaciones = get(orderResponse, ['cantidadParticipaciones'], '');

    const contract = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'contractNumber']);
    const product = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'product']);

    const associatedAccount = trim(
        CHARGE_ACCOUNT_PREFIX +
        controlDigit +
        productNumber +
        contractNumber
    );
    const fundCcv = trim(
        CHARGE_ACCOUNT_PREFIX +
        product +
        contract
    );
    const hasPreviousContributions = immContributionFunds.getIn(['steps', FIRST_STEP, 'hasPreviousContributions']);

    communicationServiceInput = {
        "email":PersonalDataHelper.getEmail(immProfile),
        "productKID": productKidDocumentUrl,
        "contract": "",
        "marketingReport": marketingReportUrl,
        "economicReport": economicReportUrl,
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": isin,
        "isinDescribe": fundName,
        "idOrder" : '',
        "channel" : CONNECTION_CHANNEL_INTERNET,
        "orderType" : BROKER_ORDER_TYPE_BUY,
        "productType" : BROKER_PRODUCT_TYPE_FUNDS_ES,
        "holders" : holderNames.join(','),
        "ccv" : fundCcv,
        "idContract": fundCcv,
        "ccc": associatedAccount,
        "market": '',
        "sharesNumber": cantidadParticipaciones,
        "orderCondition": getState().brokerProductFile.descripcionOrden,
        "sharesAmount":"" + amount,
        "termValidity": "",
        "conditionPrize": "",
        "currency": currency,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime": moment().format(DATE_FORMAT_WITH_DASHES_DATETIME),
        "periodicContribution": {
            "amount": amount,
            "contributionOrderType": hasPreviousContributions ? "MODIFICACIÓN DE COMPRA PERIÓDICA" : "ALTA DE COMPRA PERIÓDICA",
            "date":  emittedDateTime.format("YYYY-MM-DD"),
            "periodicity": PERIODICITY_DOCUMENT_SERVICE[immContributionFunds.getIn(['steps', FIRST_STEP, 'periodicityValue'])],
        }
    };

    if (ffShowExantCost) {
        communicationServiceInput = {
            ...communicationServiceInput,
            "exAnteCostsList":  translateExantCostKey(immContributionFunds.getIn(['fetchDataExt', 'response']).toJS(), "brokerHireInvestmentStep2"),
        };
    }else {
        communicationServiceInput = {
            ...communicationServiceInput,
            "costYield": costYieldObjectId,
        };
    }

    if (originCountry === PT) {
        const prospectusReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
            isin: isin,
            documentType: 'Prospectus',
            originCountry: originCountry,
        });

        const anualReportLink = apiURLBuilder.getURL('morningstarFundDocumentPDF', {
            isin: isin,
            documentType: 'Anual',
            originCountry: originCountry,
        });

        communicationServiceInput = {
            ...communicationServiceInput,
            prospectus: prospectusReportLink,
            annualEconomicReport: anualReportLink,
        };
    }

    data = {
        query: communicationServiceInput,
    };


    const dataRequest = { url: "communication", request: data };

    dispatch(contributionFundsDocumentStorageRequest());
    return APIPost(dispatch, apiURLBuilder.getURL(dataRequest.url), dataRequest.request).then(
        function () {
            dispatch(contributionFundsDocumentStorageSuccess());
        },
        function () {
            dispatch(contributionFundsDocumentStorageError());
        }
    );
}


const postAddSubscription = (dispatch, getState, dataToken, history) => {
    const immContributionFunds = getState().contributionFunds;
    const amount = parseFloat(immContributionFunds.getIn(['steps', 0, 'amount']));
    const contractNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'contractNumber']);
    const productNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'product']);
    const periodicity = immContributionFunds.getIn(['steps', 0, 'periodicityValue']);
    const currency = immContributionFunds.getIn(['steps', 0, 'customMinimumPurchaseAmount', 'currency']);
    const selectedDate = immContributionFunds.getIn(['steps', 0, 'selectedDate']);
    const formattedDate = moment(selectedDate).format('DD-MM-YYYY HH:mm:ss.SSSSSS');
    const url = apiURLBuilder.getURL('raAddPeriodicContributions')

    const requestData = {
        header: {
            version: 2
        },
        query:{
            "productId": productNumber,
            "contractCode": contractNumber,
            "amount": amount,
            "periodicity": periodicity,
            "currencyCode": currency,
            "subscriptionDate": formattedDate,
            "channel": __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
            "dataToken" : dataToken
    }};

    dispatch(requestContributionFundsInProgress())
    return APIPost(dispatch, url, requestData)
        .then(
            response => {
                const immHiredFunds = getState().brokerMyInvestments.getIn([
                    'products',
                    'funds',
                    'stocks'
                ]);
                dispatch(subscriptionSuccess(immHiredFunds.toJS()));
                dispatch(storeDocument(response));
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function(response) {
                dispatch(requestContributionFundsFailure(response.error, __CONTACT_CENTER__ && ADD_SUSCRIPTION_ERROR));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        )
        .catch(response => dispatch(requestContributionFundsFailure(response.error, __CONTACT_CENTER__ && ADD_SUSCRIPTION_ERROR)));
};

const patchSubscription = (dispatch, getState, dataToken, history) => {
    const immContributionFunds = getState().contributionFunds;
    const amount = parseFloat(immContributionFunds.getIn(['steps', 0, 'amount']));
    const contractNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'contractNumber']);
    const productNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'product']);
    const periodicity = immContributionFunds.getIn(['steps', 0, 'periodicityValue']);
    const currency = immContributionFunds.getIn(['steps', 0, 'customMinimumPurchaseAmount', 'currency']);
    const selectedDate = immContributionFunds.getIn(['steps', 0, 'selectedDate']);
    const formattedDate = moment(selectedDate).format('DD-MM-YYYY HH:mm:ss.SSSSSS');
    const subscriptionDateId = immContributionFunds.getIn(['steps', 0, 'subscriptionDateId']);
    const url = apiURLBuilder.getURL('updatePeriodicContributions');

    const requestData = {
        header: {
            version: 2
        },
        query:{
            amount: amount,
            channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
            contractCode: contractNumber,
            currencyCode: currency,
            dataToken : dataToken,
            periodicity: periodicity,
            productId: productNumber,
            subscriptionDate: formattedDate,
            subscriptionDateId: subscriptionDateId,
    }};

    dispatch(requestContributionFundsInProgress())
    return APIPost(dispatch, url, requestData)
        .then(
            response => {
                const immHiredFunds = getState().brokerMyInvestments.getIn([
                    'products',
                    'funds',
                    'stocks'
                ]);

                dispatch(subscriptionSuccess(immHiredFunds.toJS()));
                dispatch(storeDocument(response));
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function(response) {
                dispatch(requestContributionFundsFailure(response.error, __CONTACT_CENTER__ && ADD_SUSCRIPTION_ERROR));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        )
        .catch(response => dispatch(requestContributionFundsFailure(response.error, __CONTACT_CENTER__ && ADD_SUSCRIPTION_ERROR)));
};

const addSubscription = (history) => (dispatch, getState) => {
    const hasPreviousContributions = getState().contributionFunds.getIn(['steps', 0, 'hasPreviousContributions']);
    const callback = (dispatch, getState, dataToken) => {
        hasPreviousContributions ?
        patchSubscription(dispatch, getState, dataToken, history):
        postAddSubscription(dispatch, getState, dataToken, history);

    };
    const isAlreadyFetching = getState().contributionFunds.get('isFetching');

    if (!isAlreadyFetching) {
        new Promise(function() {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

const preSelectChangeSelectedAccount = (accountId, accountAmount, fundId) => (dispatch) => {
    if (accountId) {
        dispatch(setAccountNumber(accountId, accountAmount));
    }
};

const getMorningStarScreenerSecurityDetails = (data) => (dispatch, getState) => {
    const typeId = BROKER_CONTRIBUTION_FUNDS_PRODUCT_URL_PARAMETER;

    const requestData = {
            query: {
                viewId: 'price',
                LanguageId: 'es-ES',
                responseViewFormat: 'json'
            }
    }
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', {type:typeId, id:data.rows[0].SecId}), requestData)
        .then(response => dispatch(requestContributionFundsSuccess(data, response)))
        .then(() => getAccounts(dispatch, getState))
        .then(() => {
            const immContributionFunds = getState().contributionFunds;
            const isinCode = immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'isin']);
            dispatch(searchSpecificIsin(isinCode));
        })
        .catch(response => dispatch(requestContributionFundsFailure(response.error)))
};

const getMorningStarScreener = product => (dispatch, getState) => {
    const immContributionFunds = getState().contributionFunds;
    const isFetching = immContributionFunds.get('isFetching');
    const alreadyFetchedId = immContributionFunds.getIn([
        'steps',
        FIRST_STEP,
        'contributionFunds',
        'customInstitutionSecurityId'
    ]);
    const alreadyFetched = immContributionFunds.get('fetchSuccess') && alreadyFetchedId === product;

    if (!isFetching && !alreadyFetched) {
        const typeId = BROKER_CONTRIBUTION_FUNDS_PRODUCT_URL_PARAMETER;

        const requestData = {
            query: {
                securityDataPoints:
                    'AdministratorCompanyName|SecId|ISIN|Name|CustomCategoryIdName|CustomMinimumPurchaseAmount|CustomMinimumPurchaseAmountUnit|CustomMinimumAdditionalPurchaseAmount|CustomMinimumAdditionalPurchaseAmountUnit|CustomInstitutionSecurityId|ReturnM0|CustomCategoryId3',
                pageSize: 5000,
                outputType: 'json',
                languageId: 'es-ES',
                currencyId: 'EUR',
                universeIds: 'FOEUR$$ALL_2118',
                filters: `CustomInstitutionSecurityId:EQ:${product}`
            }
        };

        dispatch(requestContributionFundsInProgress());
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: typeId }),
            requestData
        )
            .then(response => {
                if (!!response.rows.length) {
                    return dispatch(getMorningStarScreenerSecurityDetails(response));
                } else {
                    return dispatch(requestContributionFundsNotFound());
                }
            })
            .catch(response => dispatch(requestContributionFundsFailure(response.error)));
    }
};

const clearFetchedPre = () => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_CLEAR_FETCHED_PRE
});

const resetFetchedPre = () => dispatch => {
    dispatch(clearFetchedPre);
};

const getAccountOwningFundFromFundId = (immAccounts, immPurchasedFunds, fundId) => {
    if (immAccounts && immPurchasedFunds && fundId) {
        const immFundFromFundId = immPurchasedFunds.find((immFund) => immFund.get('id') === fundId);

        if (immFundFromFundId) {
            const fundAssociatedAccount = immFundFromFundId.get('associatedAccountContractNumber');
            return immAccounts.find((immAccount) => immAccount.get('contractNumber') === fundAssociatedAccount);
        }
    }
};

const setContractNumber = (contractNumber, product) => ({
    type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_CONTRACT_NUMBER,
    payload: {
        contractNumber,
        product
    }
});

const getContractNumber = (fundId) => (dispatch, getState) => {
    const immPurchasedFunds = getState().brokerMyInvestments.getIn(['products', 'funds', 'stocks']);
    const immFundFromFundId = immPurchasedFunds.find((immFund) => immFund.get('id') === fundId);
    if (immFundFromFundId) {
    const product = immFundFromFundId.get('producto');
    const contractNumber = immFundFromFundId.get('numerodecontrato');
    dispatch(setContractNumber(contractNumber, product));
    dispatch(fetchPreviousContributions(contractNumber, product))
    }
}

const preSelectAccountOwningFund = (fundId) => (dispatch, getState) => {
    const immAccounts = getState().accounts.get('byId');
    const immPurchasedFunds = getState().brokerMyInvestments.getIn(['products', 'funds', 'stocks']);
    const immAccountOwningFundToPreSelect = getAccountOwningFundFromFundId(
        immAccounts,
        immPurchasedFunds,
        fundId
    );

    if (immAccountOwningFundToPreSelect) {
        const accountId = immAccountOwningFundToPreSelect.get('accountId');
        const accountBalance = immAccountOwningFundToPreSelect.getIn(['balances', 'availableBalance', 'amount']);

        dispatch(preSelectChangeSelectedAccount(accountId, accountBalance, fundId));
    }
};

const operationStarted = (customInstitutionSecurityId, fundIdToPreSelect = '') => (dispatch, getState) => {
    const fetchPurchasedFunds = dispatch(brokerMyInvestmentsActions.fetchMyInvestments()) || Promise.resolve();
    fetchPurchasedFunds
        .then(() => dispatch(getMorningStarScreener(customInstitutionSecurityId)))
        .then(() => {
            if (fundIdToPreSelect) {
                dispatch(preSelectAccountOwningFund(fundIdToPreSelect));
                dispatch(getContractNumber(fundIdToPreSelect));
            }
        });
};

const fetchPreviousContributions = (contractNumber, productId) => (dispatch, getState) => {
    dispatch(showLoading());
    const url = apiURLBuilder.getURL('brokerGetRecurringTransfersList');
    const requestData = {
        query: {
            channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
            contracts: [{contractCode: contractNumber, productId}],
        },
        header: {
            version: 2,
        }
    }
    APIPost(dispatch, url, requestData).then(
        (response) => dispatch(fetchPeriodicalContributionsSuccess(response)),
        (error) =>  dispatch(requestContributionFundsFailure(error.error))
    );
}

const fetchPeriodicalContributionsSuccess = (response) => (dispatch) => {
    if (response.recurringTransfers && response.recurringTransfers.length) {
        const amount = response.recurringTransfers[0].amount
        const periodicityRecived = response.recurringTransfers[0].periodicity
        const periodicityValue = toFirstUppercase(periodicityRecived)
        const nextInstallmentDate = moment(response.recurringTransfers[0].nextInstallmentDate, 'DD-MM-YYYY')
        const periodicityLabel =  findPeriodicityLabel(periodicityValue);
        const subscriptionDateId = response.recurringTransfers[0].subscriptionDateId
        dispatch(setPreviousContributions({amount, periodicityValue, periodicityLabel, nextInstallmentDate, subscriptionDateId}))
    }
    dispatch(hideLoading())
};

const findPeriodicityLabel = (periodicity) => {
    switch (periodicity.toLowerCase()) {
        case 'weekly':
            return formatText('brokerContributionFundStep1-weeklyPeriodicity');
        case 'monthly':
            return formatText('brokerContributionFundStep1-monthlyPeriodicity');
        case 'quarterly':
            return formatText('brokerContributionFundStep1-quarterlyPeriodicity');
        case 'semiannual':
            return formatText('brokerContributionFundStep1-semestralPeriodicity');
        case 'annual':
            return formatText('brokerContributionFundStep1-annualPeriodicity');
        default:
            return '';
    }
};
const setPreviousContributions = ({amount, periodicityValue, periodicityLabel, nextInstallmentDate, subscriptionDateId}) => {
    return ({
        type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_PREVIOUS_DATA,
        payload: {
            amount,
            periodicityValue,
            periodicityLabel,
            nextInstallmentDate,
            subscriptionDateId,
            hasPreviousContributions: true
        }
    })
};


const setDatePickerError = (error) => {
    return {
        type: actionTypes.BROKER_WIZARD_CONTRIBUTION_SET_DATEPICKER_ERROR,
        payload: {
            isValidDate: false
        }
    }
}

const validateFundDocumentsRequest = () => ({
    type: actionTypes.BROKER_CONTRIBUTION_INVESTMENT_FUND_VALIDATE_DOCUMENTS_REQUEST
});

const validateFundDocumentsSuccess = enableEconomicReport => ({
    type: actionTypes.BROKER_CONTRIBUTION_INVESTMENT_FUND_VALIDATE_DOCUMENTS_SUCCESS,
    payload: {
        enableEconomicReport
    }
});

const validateFundDocumentsFailure = () => ({
    type: actionTypes.BROKER_CONTRIBUTION_INVESTMENT_FUND_VALIDATE_DOCUMENTS_FAILURE
});

const validateFundDocuments = (mustControlEconomicReport, history) => (dispatch, getState) => {
    const immContributionFunds = getState().contributionFunds;
    const isin = immContributionFunds.getIn(['contributionFunds', 'isin']);
    dispatch(validateFundDocumentsRequest());
    const immProfile = getState().profile;
    const immGlobalVariables = getState().globalVariables;
    const originCountry = immProfile.get('originCountry')
    const memories = immGlobalVariables.getIn(['variables', 'parameters', 'memories', 'memories']);
    let publicSiteUrl = apiURLBuilder.getPublicSiteUrl(false);
    if (!!publicSiteUrl && publicSiteUrl.slice(publicSiteUrl.length - 3, -2) === "/") {
        publicSiteUrl = publicSiteUrl.slice(0, -3);
    }
    const dfi = apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: isin, documentType: 'DFI', originCountry: originCountry})
    const mc = memories
        ? `${ publicSiteUrl}${memories.trim()}${isin}.pdf?originCountry=${originCountry}`
        : '';
    const mustShowMC = showMemories(originCountry , isin)
    if(true && !!dfi && (!mustShowMC || (!!mc )) ) {
        let arrayPromises = [APIGet(dispatch, dfi, {})];
        if (mustShowMC) {
            arrayPromises.push(APIGet(dispatch, mc, {}))
        }

        if (originCountry === PT) {
            const prospectus = apiURLBuilder.getURL('morningstarFundDocumentPDF', { isin: isin, documentType: 'Prospectus', originCountry: originCountry })
            const anual = apiURLBuilder.getURL('morningstarFundDocumentPDF', { isin: isin, documentType: 'Anual', originCountry: originCountry })
            arrayPromises.push(APIGet(dispatch, prospectus, {}))
            arrayPromises.push(APIGet(dispatch, anual, {}))
        }

        Promise.all(arrayPromises)
            .then(() => {
                const ies = apiURLBuilder.getURL('morningstarFundDocumentPDF', {isin: isin, documentType: 'InformeSemestral', originCountry: originCountry});
                return APIGet(dispatch, ies, {})
                    .then(() => {
                        dispatch(validateFundDocumentsSuccess(true));
                    }).catch(() => {
                        if (mustControlEconomicReport) {
                            dispatch(errorActions.show('', true, history));
                            dispatch(validateFundDocumentsFailure());
                        } else {
                            dispatch(validateFundDocumentsSuccess(false));
                        }
                    })
            }).catch(() => {
                dispatch(errorActions.show('', true, history));
                dispatch(validateFundDocumentsFailure());
            })
    } else {
        dispatch(errorActions.show('', true, history));
        dispatch(validateFundDocumentsFailure());
    }
};

const validateEconomicReport = (history) => (dispatch, getState) => {
    const typeId = BROKER_CONTRIBUTION_FUNDS_PRODUCT_URL_PARAMETER;
    const immContributionFunds = getState().contributionFunds;
    const requestData = {
            query: {
                viewId: 'fullNew',
                responseViewFormat: 'json'
            }
    }

    const secId = !!immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds'])
        ? immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'secId'])
        : null;

        dispatch(validateFundDocumentsRequest());


    return APIGet(
            dispatch,
            apiURLBuilder.getURL(
                'brokerGetMorningStarScreenerSecurityDetails',
                {
                    type: typeId,
                    id: secId,
                }
            ),
            requestData
        )
        .then((response) => {
            const mustControlEconomicReport =
                !!response[0] && !!response[0].InceptionDate
                    ? moment(response[0].InceptionDate).isBefore(moment().subtract(1, 'year'))
                    : false;
            dispatch(validateFundDocuments(mustControlEconomicReport, history));
        }).catch(() => {
            dispatch(errorActions.show('', true, history));
            dispatch(validateFundDocumentsFailure());
        });
}


module.exports = {
    operationStarted,
    getMorningStarScreener,
    reset,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    setAmount,
    validateStep,
    changeReadChecked,
    addSubscription,
    resetFetchedPre,
    postExtantCostsBuyFunds,
    validateEconomicReport,
    setValidityDate,
    setPeriodicity,
    setDatePickerError,
};
